import { size, compose, chunk, over, range, identity, zipObject, clamp } from 'lodash/fp';
import { createScopedReducer } from '@mews/framework';
import {
    META_STATE_SUCCEEDED,
    META_STATE_FAILED,
    META_STATE_STARTED,
} from '@mews-commander/legacy-entities/src/constants';
import {
    PAGINATION_CREATED,
    PAGE_CHANGED,
    PAGE_FETCH_FAILED,
    PAGE_FETCH_SUCCEEDED,
    PAGE_FETCH_STARTED,
    PAGINATION_IDS_CHANGED,
} from './actions';

const INITIAL_STATE = {
    totalCount: 0,
    pageSize: 0,
    selectedPage: 0,
    pages: {},
    ...META_STATE_SUCCEEDED,
};

const chunkPages = (pageSize: $TSFixMe) =>
    compose(
        ([indexes, pages]) => zipObject(indexes, pages),
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        over([(arr) => range(0, size(arr)), identity]),
        chunk(pageSize)
    );

export default createScopedReducer(INITIAL_STATE, {
    [PAGINATION_CREATED]: (state: $TSFixMe, { pageSize, ids }: $TSFixMe) => {
        const paginationState = ids
            ? {
                  totalCount: size(ids),
                  pageSize,
                  // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
                  pages: chunkPages(pageSize)(ids),
              }
            : {
                  pageSize,
              };
        return {
            ...state,
            ...paginationState,
        };
    },

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [PAGE_CHANGED]: (state, selectedPage) => ({
        ...state,
        selectedPage,
    }),

    [PAGE_FETCH_STARTED]: (state: $TSFixMe) => ({
        ...state,
        ...META_STATE_STARTED,
    }),

    [PAGE_FETCH_FAILED]: (state: $TSFixMe) => ({
        ...state,
        ...META_STATE_FAILED,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [PAGE_FETCH_SUCCEEDED]: (state, { page, ids, totalCount }: $TSFixMe) => ({
        ...state,
        totalCount,
        selectedPage: page,

        pages: {
            ...state.pages,
            [page]: [...ids],
        },

        ...META_STATE_SUCCEEDED,
    }),

    [PAGINATION_IDS_CHANGED]: (state: $TSFixMe, { ids }: $TSFixMe) => {
        const { pageSize, selectedPage } = state;
        // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
        const pages = chunkPages(pageSize)(ids);

        return {
            ...state,
            pages,
            // @ts-expect-error $TSFixMeError: Argument of type 'unknown' is not assignable to parameter of type 'string | object | null | undefined'.
            selectedPage: clamp(0, size(pages) - 1, selectedPage),
            totalCount: size(ids),
        };
    },
});
